import { useCallback } from 'react'

import { useTranslation } from 'react-i18next'
import { DEFAULT_LANGUAGE, LANGUAGES } from 'shared/constants/Languages'

export const useLanguageSelector = () => {
  const { i18n } = useTranslation()

  const changeLanguage = useCallback(
    (lang: string) => {
      if (lang !== i18n.language) {
        i18n.changeLanguage(lang)
      }
    },
    [i18n]
  )

  const currentLanguageOption = (() => {
    const code = i18n.language || DEFAULT_LANGUAGE
    const match =
      LANGUAGES.find(
        l =>
          l.value === code ||
          l.alternativeValue === code ||
          (code && code.startsWith(`${l.value}-`))
      ) || LANGUAGES.find(l => l.value === DEFAULT_LANGUAGE)
    return match!
  })()

  return { changeLanguage, currentLanguageOption, languageOptions: LANGUAGES }
}
